module.exports = __webpack_public_path__ + "img/descImg7.e0aff29f.png";